module.exports = __webpack_public_path__ + "media/src/assets/Images/Warning-7b6ad50d6049099fc2e008342c254266.svg";